"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentElementWrapper = void 0;
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../../../constants/constants");
const document_1 = require("../../../../../reducers/slices/document/document");
const form_element_1 = require("./form_element");
const react_redux_1 = require("react-redux");
const core_1 = require("@dnd-kit/core");
const properties_component_1 = require("./properties_component");
const scaleFunction_1 = require("../../../../../helpers/scaleFunction");
function DocumentElementWrapper({ element, preview, snapToGrid }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const dispatch = (0, react_redux_1.useDispatch)();
    const Elem = form_element_1.DocumentElements[element.type].documentComponent;
    const [mouseIsOver, setMouseIsOver] = (0, react_1.useState)(false);
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const [labelPosition, setLabelPosition] = (0, react_1.useState)("top");
    const wrapperRef = (0, react_1.useRef)(null);
    const { selectedDocument, selectedElementID, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    // Get document dimensions (from PDF or defaults)
    // Use selectedDocument as dependency to recalculate when document changes
    const docDimensions = (0, react_1.useMemo)(() => (0, scaleFunction_1.getDocumentDimensions)(selectedDocument), [selectedDocument]);
    // Detect if element is still being created (has temp ID)
    const isTempId = typeof element._id === "string" && element._id.startsWith("temp_");
    const isCreating = isTempId;
    // Handle click outside to unfocus on mobile
    (0, react_1.useEffect)(() => {
        if (!constants_1.IS_MOBILE || !isFocused)
            return;
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsFocused(false);
                setMouseIsOver(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [isFocused]);
    const scaleFactor = (0, scaleFunction_1.getScaleFactor)();
    // Get signer info if field is assigned to a specific signer
    const getSignerInfo = () => {
        var _a, _b;
        try {
            const userObj = (_a = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _a === void 0 ? void 0 : _a.user;
            const userId = ((_b = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _b === void 0 ? void 0 : _b.user_id) || (userObj === null || userObj === void 0 ? void 0 : userObj._id);
            const userEmail = userObj === null || userObj === void 0 ? void 0 : userObj.email;
            // Check if field has any user assignment
            const hasUserAssignment = userId || userEmail || userObj;
            if (!hasUserAssignment) {
                return null;
            }
            // Helper to extract name from user object (handles different property names)
            const extractUserName = (user) => {
                if (!user)
                    return "";
                const firstName = user.first_name || user.name || "";
                const lastName = user.last_name || user.surname || "";
                return `${firstName} ${lastName}`.trim();
            };
            // Try to find signer in document signers list first
            if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) && Array.isArray(selectedDocument.signers)) {
                const signer = selectedDocument.signers.find((s) => (userId && (s.user_id === userId || s._id === userId)) ||
                    (userEmail && s.email === userEmail));
                if (signer) {
                    return {
                        name: `${signer.first_name || ""} ${signer.last_name || ""}`.trim() || signer.email,
                        email: signer.email,
                    };
                }
            }
            // Fallback to user info from element
            if (userObj) {
                const email = userEmail || "unknown";
                const name = extractUserName(userObj);
                return {
                    name: name || email,
                    email: email,
                };
            }
            return null;
        }
        catch (error) {
            console.warn("Error getting signer info:", error);
            return null;
        }
    };
    const signerInfo = getSignerInfo();
    // Generate a unique color for each user based on their email
    const getUserColor = (email) => {
        // Simple hash function to generate consistent color from email
        let hash = 0;
        for (let i = 0; i < email.length; i++) {
            hash = email.charCodeAt(i) + ((hash << 5) - hash);
        }
        // Generate HSL color with good saturation and lightness for readability
        const hue = Math.abs(hash % 360);
        const saturation = 65 + (Math.abs(hash) % 20); // 65-85%
        const lightness = 45 + (Math.abs(hash >> 8) % 15); // 45-60%
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };
    // Dynamic label positioning - position label opposite to cursor location
    const handleMouseMove = (e) => {
        if (!signerInfo)
            return;
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        // Calculate distances to edges to find closest edge (where cursor is)
        const distanceToTop = y;
        const distanceToBottom = rect.height - y;
        const distanceToLeft = x;
        const distanceToRight = rect.width - x;
        // Find the closest edge (where cursor is pointing) and position label on opposite side
        const minDistance = Math.min(distanceToTop, distanceToBottom, distanceToLeft, distanceToRight);
        if (minDistance === distanceToTop) {
            // Cursor near top, position label at bottom
            setLabelPosition("bottom");
        }
        else if (minDistance === distanceToBottom) {
            // Cursor near bottom, position label at top
            setLabelPosition("top");
        }
        else if (minDistance === distanceToLeft) {
            // Cursor near left, position label at right
            setLabelPosition("right");
        }
        else {
            // Cursor near right, position label at left
            setLabelPosition("left");
        }
    };
    // Get label classes based on position
    const getLabelClasses = () => {
        const baseClasses = "absolute text-white px-2 py-1 rounded text-xs whitespace-nowrap shadow-lg z-[1000] pointer-events-none flex items-center gap-1";
        switch (labelPosition) {
            case "top":
                return `${baseClasses} -top-8 left-0`;
            case "bottom":
                return `${baseClasses} -bottom-8 left-0`;
            case "left":
                return `${baseClasses} top-0 -left-2 -translate-x-full`;
            case "right":
                return `${baseClasses} top-0 -right-2 translate-x-full`;
            default:
                return `${baseClasses} -top-8 left-0`;
        }
    };
    // Per client request 2026-04-29: Signature and Initials fields cannot be
    // moved once the document leaves DRAFT (i.e. after the author publishes —
    // the sign/preview/completed views). The editor (DRAFT) keeps full move
    // ability so the author can place them. Hidden/disabled rather than
    // removed so we can revisit move ergonomics in a future iteration.
    const isSignatureOrInitials = element.type === "Signature" || element.type === "Initials";
    const isMoveDisabled = isSignatureOrInitials && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "DRAFT";
    const draggable = (0, core_1.useDraggable)({
        id: `translation-btn-${element.type}_${element._id}`,
        data: {
            type: element.type,
            elementId: element._id,
            dragType: "translation",
            isDocumentBtnElement: true,
        },
        disabled: isCreating || isMoveDisabled, // Disable drag until backend responds with real ID
    });
    // Separate ref for drag handle (activator) vs positioned element
    const { setNodeRef, setActivatorNodeRef, listeners, attributes, isDragging, transform } = draggable;
    (0, core_1.useDndMonitor)({
        onDragStart: (e) => {
            dispatch((0, document_1.setOnDrag)(true));
        },
        onDragCancel: (e) => {
            dispatch((0, document_1.setOnDrag)(false));
        },
        onDragEnd: (e) => {
            var _a, _b, _c, _d, _e, _f, _g;
            dispatch((0, document_1.setOnDrag)(false));
            const { active, over, delta } = e;
            const dragType = (_b = (_a = active === null || active === void 0 ? void 0 : active.data) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.dragType;
            const elementId = (_d = (_c = active === null || active === void 0 ? void 0 : active.data) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.elementId;
            if (dragType == "translation" && elementId === element._id) {
                // GUARD: Only this element's drag handler should process
                // Prevents duplicate updates when multiple wrappers listen to same event
                const expectedDragId = `translation-btn-${element.type}_${element._id}`;
                if (active.id !== expectedDragId) {
                    return; // Not our drag event, skip
                }
                // Get the actual page container dimensions to calculate proper delta conversion
                const pageElement = document.getElementById(`document_${element.page || 0}`);
                const pageWidth = (pageElement === null || pageElement === void 0 ? void 0 : pageElement.clientWidth) || (0, scaleFunction_1.scaleFunction)(docDimensions.width, docDimensions.width);
                const pageHeight = (pageElement === null || pageElement === void 0 ? void 0 : pageElement.clientHeight) || (0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width);
                // Convert screen pixel delta to original document coordinates
                const deltaXInDocCoords = (Number((delta === null || delta === void 0 ? void 0 : delta.x) || 0) / pageWidth) * docDimensions.width;
                const deltaYInDocCoords = (Number((delta === null || delta === void 0 ? void 0 : delta.y) || 0) / pageHeight) * docDimensions.height;
                let _x = Number(((_e = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _e === void 0 ? void 0 : _e.x) || 0) + deltaXInDocCoords;
                let _y = Number(((_f = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _f === void 0 ? void 0 : _f.y) || 0) + deltaYInDocCoords;
                // Clamp position so the field stays fully on the page. Width-aware
                // bounds prevent the right/bottom edge of the field from ending up
                // past the page edge and rendering off-page.
                const elemW = element.width || 150;
                const elemH = element.height || 50;
                _x = Math.max(0, Math.min(_x, docDimensions.width - elemW));
                _y = Math.max(0, Math.min(_y, docDimensions.height - elemH));
                // Allow coordinates to be 0 (valid position)
                if (typeof _y === "number" && typeof _x === "number") {
                    // Get fresh element from Redux to avoid overwriting recent changes (like user assignment)
                    const latestElement = (_g = selectedDocumentElements.find((x) => x._id === element._id)) !== null && _g !== void 0 ? _g : element;
                    let updatedElement = Object.assign(Object.assign({}, latestElement), { extra_attributes: Object.assign(Object.assign({}, latestElement.extra_attributes), { x: _x, y: _y }) });
                    // Update Redux immediately (instant UI feedback)
                    dispatch((0, document_1.editSelectedDocumentElements)(updatedElement));
                    // Queue for batched save (no immediate backend call)
                    dispatch((0, document_1.addPendingUpdate)({
                        elementId: element._id,
                        changes: {
                            extra_attributes: {
                                x: _x,
                                y: _y,
                            },
                        },
                    }));
                }
            }
        },
    });
    // Check if element is fillable (has x/y positioning)
    const isFillable = ((_a = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _a === void 0 ? void 0 : _a.edit_type) === "fillable" || ((_b = element.extra_attributes) === null || _b === void 0 ? void 0 : _b.x) !== undefined;
    // Check if this is a Text element containing only an image (likely a PDF page background)
    const textContent = ((_c = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _c === void 0 ? void 0 : _c.text) || "";
    const isPageBackground = element.type === "Text" && (textContent.trim().startsWith("<img") ||
        (textContent.trim().startsWith("<p>") && textContent.includes("<img") && !textContent.replace(/<img[^>]*>/g, "").replace(/<\/?p>/g, "").trim()));
    // Check if this is a Signature or Initials field (these need explicit dimensions)
    const isSignatureOrInitialsField = element.type === "Signature" || element.type === "Initials";
    // Element dimensions in original document space
    // For page backgrounds (PDF images), use full page dimensions
    // On mobile: make container LARGER so content has room, then scale down visually
    const isMobile = scaleFactor < 0.6;
    const containerMultiplier = isMobile ? 2 : 1; // 2x container size on mobile
    const originalWidth = isPageBackground ? docDimensions.width : (element.width || 144) * containerMultiplier;
    const originalHeight = isPageBackground ? docDimensions.height : (element.height || 48) * containerMultiplier;
    // CSS transform scale for mobile - scales the entire field visually back down
    // 2x container * 0.5 scale = same visual size as desktop, but with room for content
    const fieldTransformScale = isMobile ? 0.5 : 1;
    // For page backgrounds, always treat as positioned at 0,0 even if x is undefined
    const hasPosition = ((_d = element.extra_attributes) === null || _d === void 0 ? void 0 : _d.x) !== undefined || isPageBackground;
    const xPos = isPageBackground ? 0 : (((_e = element.extra_attributes) === null || _e === void 0 ? void 0 : _e.x) || 0);
    const yPos = isPageBackground ? 0 : (((_f = element.extra_attributes) === null || _f === void 0 ? void 0 : _f.y) || 0);
    // Position and size style for absolutely positioned elements
    // Use percentage positioning relative to the document container
    // Only Signature/Initials and page backgrounds get explicit dimensions (others auto-size to content)
    // Lift the active wrapper above siblings while controls are showing so the
    // move-handle (positioned at the field's edge) is reachable even when the
    // field is small. Without this, an adjacent input field's hit area can sit
    // on top of the handle and capture the click.
    const isActive = mouseIsOver || isFocused || isDragging || (scaleFactor < 0.6);
    const positionStyle = hasPosition
        ? Object.assign(Object.assign({ position: "absolute", 
            // Page backgrounds at z-index 0, fields at z-index 50, active field at 60
            zIndex: isPageBackground ? 0 : (isActive ? 60 : 50), left: `${(xPos / docDimensions.width) * 100}%`, top: `${(yPos / docDimensions.height) * 100}%` }, ((isSignatureOrInitialsField || isPageBackground || (element === null || element === void 0 ? void 0 : element.width) !== undefined)
            ? {
                width: `${(originalWidth / docDimensions.width) * 100}%`,
                height: `${(originalHeight / docDimensions.height) * 100}%`,
            }
            : {})), (isPageBackground ? { pointerEvents: "none" } : {})) : {};
    // Transform for drag translation and mobile scaling
    // Container is 2x on mobile, scale back to 50% (net effect: larger space for content, smaller visual)
    // Page backgrounds should NOT be scaled - they fill 100% of the container already
    const baseTransform = (fieldTransformScale < 1 && !isPageBackground) ? `scale(${fieldTransformScale})` : '';
    const dragTransform = transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : '';
    const combinedTransform = [baseTransform, dragTransform].filter(Boolean).join(' ') || undefined;
    // Show controls on hover (desktop) or focus (mobile)
    // Always show controls (move icon) on mobile for easier interaction
    const showControls = mouseIsOver || isFocused || isDragging || isMobile;
    if (((_g = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _g === void 0 ? void 0 : _g.edit_type) === "fillable") {
        return (react_1.default.createElement("div", { id: element === null || element === void 0 ? void 0 : element._id, ref: (node) => {
                wrapperRef.current = node;
                setNodeRef(node);
            }, style: Object.assign(Object.assign({}, positionStyle), (combinedTransform ? { transform: combinedTransform, transformOrigin: "top left" } : {})), onMouseEnter: (e) => {
                dispatch((0, document_1.setSelectedElementID)(element._id));
                setMouseIsOver(true);
            }, onMouseLeave: (e) => {
                setMouseIsOver(false);
            }, onTouchStart: (e) => {
                // Mobile: show drag handle on touch
                dispatch((0, document_1.setSelectedElementID)(element._id));
                setMouseIsOver(true);
                setIsFocused(true);
            }, onMouseMove: handleMouseMove, className: `cursor-pointer ${isDragging ? "opacity-80 z-50" : ""} ${isCreating ? "pointer-events-none" : ""}` },
            (selectedElementID === element._id || showControls) && !isCreating && !isMoveDisabled && (react_1.default.createElement(properties_component_1.PropertiesComponent, { element: element, dragHandleRef: setActivatorNodeRef, dragListeners: listeners, dragAttributes: attributes })),
            react_1.default.createElement("div", { className: `${showControls && "bg-primary/10 rounded-sm"} ${isCreating ? "animate-pulse border-2 border-primary/50 rounded-sm" : ""}`, style: { width: "100%", height: "100%" } },
                react_1.default.createElement(Elem, { elementInstance: element })),
            showControls && signerInfo && (react_1.default.createElement("div", { className: getLabelClasses(), style: { backgroundColor: getUserColor(signerInfo.email) } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUser, className: "text-xs" }),
                react_1.default.createElement("span", null, signerInfo.name)))));
    }
    // Non-fillable elements (inline content like Text, Paragraph)
    // For page backgrounds, render without interactive wrappers to avoid z-index issues
    if (isPageBackground) {
        return (react_1.default.createElement("div", { id: element === null || element === void 0 ? void 0 : element._id, ref: (node) => {
                wrapperRef.current = node;
                setNodeRef(node);
            }, style: Object.assign(Object.assign({}, positionStyle), { 
                // Ensure page backgrounds don't create extra stacking contexts
                isolation: "auto" }), className: "w-full h-full" },
            react_1.default.createElement(Elem, { elementInstance: element })));
    }
    return (react_1.default.createElement("div", { id: element === null || element === void 0 ? void 0 : element._id, ref: (node) => {
            wrapperRef.current = node;
            setNodeRef(node);
        }, style: Object.assign(Object.assign({}, positionStyle), (combinedTransform ? { transform: combinedTransform, transformOrigin: "top left" } : {})), onDoubleClick: (e) => {
            dispatch((0, document_1.setSelectedElement)(null));
            if (selectedElementID === (element === null || element === void 0 ? void 0 : element._id)) {
                dispatch((0, document_1.setSelectedElementID)(""));
            }
            else {
                dispatch((0, document_1.setSelectedElementID)(element._id));
            }
        }, onMouseEnter: (e) => {
            setMouseIsOver(true);
        }, onMouseLeave: (e) => {
            setMouseIsOver(false);
        }, onTouchStart: (e) => {
            // Mobile: show drag handle on touch
            setMouseIsOver(true);
            setIsFocused(true);
        }, onMouseMove: handleMouseMove, className: `relative cursor-pointer inline-block ${isCreating ? "pointer-events-none" : ""} ${isDragging ? "opacity-80 z-50" : ""}` },
        (showControls) && !isCreating && (react_1.default.createElement(properties_component_1.PropertiesComponent, { element: element, dragHandleRef: setActivatorNodeRef, dragListeners: listeners, dragAttributes: attributes })),
        react_1.default.createElement("div", { className: `${showControls && "bg-primary/10 rounded-sm"} ${isCreating ? "animate-pulse border-2 border-primary/50 rounded-sm" : ""}` },
            react_1.default.createElement(Elem, { elementInstance: element })),
        showControls && signerInfo && (react_1.default.createElement("div", { className: getLabelClasses(), style: { backgroundColor: getUserColor(signerInfo.email) } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUser, className: "text-xs" }),
            react_1.default.createElement("span", null, signerInfo.name)))));
}
exports.DocumentElementWrapper = DocumentElementWrapper;
